import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { MasterService } from './master.service';
import { UsersService } from '../users/users.service';
import { ActiveUserResolver } from 'src/app/auth/active-user.resolver';

@Injectable({
  providedIn: 'root',
})
export class MasterResolver implements Resolve<{}> {
  constructor(
    private masterService: MasterService,
    private usersService: UsersService,
    private activeUserResolver: ActiveUserResolver
  ) {}

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<{}> {
    let business =
      route.paramMap.get('business') ?? route.parent?.paramMap.get('business');

    if (!business) {
      let activeUser = this.usersService.getActiveUser();

      if (!activeUser.business) {
        const resolvedUser = await this.activeUserResolver.resolve();

        if (resolvedUser?.business) {
          activeUser = resolvedUser;
        }
      }

      business = activeUser.business?.toLowerCase() ?? '';
    }

    if (business && this.usersService.business.value !== business) {
      this.usersService.business.next(business);
    }

    await this.masterService.setMaster();

    return {};
  }
}
